import type { OutputLoginQrCodeTargetAccountSearchConditions } from '~/types/business/OutputLoginQrCodeTargetAccountSearchConditions';

/**
 * ページネーション情報
 */
type Pagination = {
  /** 現在のページ番号 */
  currentPage: number;
  /** 1ページあたりの表示件数 */
  displayCount: number;
};

/**
 * ログイン用QRコード出力画面の検索条件
 */
type OutputLoginQrCodeSearchConditions = {
  /** ページネーション情報 */
  pagination: Pagination;
  /** 絞り込み条件 */
  searchConditions: OutputLoginQrCodeTargetAccountSearchConditions;
};

/**
 * ログイン用QRコード出力画面の検索条件ストア
 */
export const useOutputLoginQrCodeSearchConditionsStore = defineStore('outputLoginQrCodeSearchConditions', {
  state: (): OutputLoginQrCodeSearchConditions => ({
    pagination: {
      currentPage: 1,
      displayCount: 10,
    },
    searchConditions: {
      platId: '',
      accountType: '',
      userNameSei: '',
      userNameMei: '',
      stationName: '',
      userCompanyName: '',
    },
  }),
  // Stateをセッションストレージに保存する
  persist: {
    storage: piniaPluginPersistedstate.sessionStorage(),
  },
  actions: {
    /**
     * 検索条件をリセットする
     */
    resetSearchConditions() {
      this.$reset();
    },
  },
});
